import { render } from "./KingdomEventNotification.vue?vue&type=template&id=3e93263a"
import script from "./KingdomEventNotification.vue?vue&type=script&lang=js"
export * from "./KingdomEventNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/KingdomEventNotification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e93263a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e93263a', __exports__)) {
    api.reload('3e93263a', __exports__)
  }
  
  module.hot.accept("./KingdomEventNotification.vue?vue&type=template&id=3e93263a", () => {
    api.rerender('3e93263a', render)
  })

}


export default __exports__